import { Component, inject, ChangeDetectionStrategy, signal } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatLegacyButtonModule as MatButtonModule } from '@angular/material/legacy-button';
import { MatIconModule } from '@angular/material/icon';
import { Store, select } from '@ngrx/store';
import { ZefReactiveComponent } from '@zerops/zef/core';
import { selectZefDialogState, zefDialogClose, ZefDialogModule } from '@zerops/zef/dialog';
import { ZefCopyToClipboardModule } from '@zerops/zef/copy-to-clipboard';
import { ZuiTipCardComponent } from '@zerops/zui/tip-card';
import { Subject } from 'rxjs';
import { map, tap } from 'rxjs/operators';
import { FEATURE_NAME } from './recovery-code-issued-dialog.constant';

@Component({
  selector: 'z-recovery-code-issued-dialog',
  templateUrl: './recovery-code-issued-dialog.feature.html',
  styleUrl: './recovery-code-issued-dialog.feature.scss',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    CommonModule,
    MatButtonModule,
    MatIconModule,
    ZefDialogModule,
    ZefCopyToClipboardModule,
    ZuiTipCardComponent
  ]
})
export class RecoveryCodeIssuedDialogFeature extends ZefReactiveComponent {
  // # Deps
  #store = inject(Store);

  // # Event Streams
  onClose$ = new Subject<void>();

  // # Signals
  showCode = signal<boolean>(false);

  // # Data
  // -- sync
  key = FEATURE_NAME;

  // -- async
  dialogState$ = this.#store.pipe(select(selectZefDialogState(FEATURE_NAME)));
  open$ = this.dialogState$.pipe(map((data) => data?.state));
  code$ = this.dialogState$.pipe(map((data) => data?.meta?.code));

  // # State resolver
  state = this.$connect({
    open: this.open$.pipe(
      tap((open) => {
        if (open) {
          this.showCode.set(false);
        }
      })
    ),
    code: this.code$
  });

  // # Dispatcher
  constructor() {
    super();

    this.$dispatchActions([
      this.onClose$.pipe(
        map(() => zefDialogClose({ key: FEATURE_NAME }))
      )
    ]);
  }
}
